import { useQuery, useQueryClient } from "@tanstack/react-query";

const leaveMainDataKey = 'leaveData';

const fetchLeaveData = async () => {
    return {
        year: null,
        employee: null,
    }
}

export const useLeaveData = () => {
    const queryClient = useQueryClient();

    const { data: leaveData = [] } = useQuery({
        queryKey: [leaveMainDataKey],
        queryFn: fetchLeaveData,
        staleTime: Infinity
    });

    const setLeaveData = (key, value) => {
        queryClient.setQueryData([leaveMainDataKey], (oldData) => ({
            ...oldData,
            [key]: value,
        }))
    }

    return {
        leaveData,
        setLeaveData,
    }
}